import { css } from '@/styled-system/css';

export const formContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
  maxWidth: '404px',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginBottom: '3x',
});

export const fieldLabel = css({
  fontSize: 'md',
  fontWeight: 'bold',
  color: 'hpxBlue600',
  marginBottom: 'xs',
});

export const commentTextarea = css({
  width: '100%',
  minHeight: '120px',
  padding: '1x',
  fontSize: 'md',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderRadius: '4px',
  resize: 'vertical',
  fontFamily: 'inherit',
  _focus: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
    borderColor: 'hpxTeal500',
  },
});

export const tagsContainer = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'xs',
  marginTop: 'xs',
});

export const tag = css({
  paddingTop: '4px',
  paddingBottom: '4px',
  paddingLeft: '6px',
  paddingRight: '6px',
  fontSize: 'sm',
  lineHeight: '1.4',
  borderRadius: '20px',
  borderWidth: '1.5px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  bg: 'hpxWhite',
  color: 'hpxBlue500',
  cursor: 'pointer',
  transitionProperty: 'all',
  transitionDuration: '0.15s',
  _hover: {
    borderColor: 'hpxTeal500',
    color: 'hpxTeal600',
    bg: 'hpxTeal100',
  },
});

export const tagSelected = css({
  bg: 'hpxTeal100',
  borderColor: 'hpxTeal500',
  color: 'hpxTeal600',
  fontWeight: 'bold',
});

export const errorMessage = css({
  color: 'hpxRed400',
  fontSize: 'sm',
});

export const buttonRow = css({
  display: 'flex',
  gap: '2x',
  '& button': {
    flex: 1,
  },
});

export const successMessage = css({
  color: 'hpxTeal600',
  fontSize: 'md',
  fontWeight: 'bold',
  padding: '2x',
  bg: 'hpxTeal100',
  borderRadius: '4px',
  textAlign: 'center',
});
